import { module as BaseModule } from 'modujs';

import GLightbox from 'glightbox';


export default class extends BaseModule {
  constructor(m) {
    super(m);
  }

  init() {
    const el = this.el;
    

    const lightbox = GLightbox({
      selector: '.gbox',
      loop: true
    });

    /* const lightbox = GLightbox({
      touchNavigation: true,
      loop: true,
      autoplayVideos: true
  }); */
  }
}